export default {"src":"/_next/static/media/call.2c4f7ade.svg","height":17,"width":19};